<template>
  <transition name="modal-fade">
    <section
      v-if="$store.state.isModal"
      class="base-modal fixed wh100 left0 top0 flex-center z999"
      @mouseup="releaseClick"
    >
      <slot />
    </section>
  </transition>
</template>

<script>
  export default {
    name: 'BaseModal',
    methods: {
      releaseClick () {
        this.$store.state.isClickModal
          ? this.$store.commit('SET_KEY_VALUE', {
              key: 'isClickModal',
              value: false
            })
          : this.close();
      },
      close () {
        this.$store.commit('RESET_MODAL_DATA');
        this.$store.commit('SET_MODAL', { val: false, name: '' });
      }
    }
  };
</script>

<style lang="less">
  .base-modal {
    background-color: rgba(0, 0, 0, 0.6);
  }
</style>
